<template>
  <div class="row">
    <div class="col-lg-5 mb-3">
      <div class="filter-wrapper p-3 rounded" style="background-color: #e0dcdc">
        <router-view name="filter"></router-view>
      </div>
    </div>

    <div class="col-lg-7 mb-3">
      <div class="p-3 rounded" style="background-color: #e0dcdc">
        <router-view name="table"></router-view>
        <router-view name="form"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
  export default {}
</script>
